<div class="slider">
  <input checked type=radio name="slider" id="slide1" />
  <input type=radio name="slider" id="slide2" />
  <input type=radio name="slider" id="slide3" />
  <input type=radio name="slider" id="slide4" />
  <input type=radio name="slider" id="slide5" />

  <div class="slider-wrapper">
    <div class=inner>
      <article>
        <div class="info top-left hidden-xs">
          <img class="logo_slider" src="/assets/images/slider/logo_slider.png"></div>
          <div class="info top-right hidden-xs">
            <img class="logo_slider" src="/assets/images/slider/copy_slider.png"></div>

            <img src="/assets/images/slider/banner.jpg" class="hidden-xs">
            <img src="/assets/images/slider/banner_mobile.png" class="visible-xs">
          </article>

          <article>
            <div class="info top-left hidden-xs">
              <img class="logo_slider" src="/assets/images/slider/logo_slider.png"></div>
              <div class="info top-right hidden-xs">
                <img class="logo_slider" src="/assets/images/slider/copy_slider.png"></div>

                <img src="/assets/images/slider/banner.jpg" class="hidden-xs">
                <img src="/assets/images/slider/banner_mobile.png" class="visible-xs">
              </article>

              <article>
                <div class="info top-left hidden-xs">
                  <img class="logo_slider" src="/assets/images/slider/logo_slider.png"></div>
                  <div class="info top-right hidden-xs">
                    <img class="logo_slider" src="/assets/images/slider/copy_slider.png"></div>

                    <img src="/assets/images/slider/banner.jpg" class="hidden-xs">
                    <img src="/assets/images/slider/banner_mobile.png" class="visible-xs">
                  </article>

                </div>
                <!-- .slider-dot-control -->
                <div class="slider-dot-control hidden-xs">
                  <label for=slide1></label>
                  <label for=slide2></label>
                  <label for=slide3></label>
                </div>
                <!-- .inner -->
              </div>
              <!-- .slider-wrapper -->

              <!-- <div class="slider-prev-next-control">
              <label for=slide1></label>
              <label for=slide2></label>
              <label for=slide3></label>
            </div> -->
            <!-- .slider-prev-next-control -->

          </div>

          <!-- categories filter  -->
          <div class="categories">
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation"
                style="cursor: pointer;"
                [ngClass]="{'active': !selectedDepartmentId}">
                <a (click)="goToDepartment(null)"
                  role="tab"
                  data-toggle="tab"

                  >TODOS
                </a>
              </li>
              @for (department of departments; track department) {
                <li
                  style="cursor: pointer;"
                  role="presentation"
                  [ngClass]="{'active': department.id == selectedDepartmentId}"
                  >
                  <a (click)="goToDepartment(department.id)"
                    role="tab"
                    data-toggle="tab"
                  >{{department.name}}</a>
                </li>
              }
            </ul>
          </div>

